var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button-text-link",class:[_vm.styleClassName, _vm.sizeClassName],attrs:{"href":_vm.href,"download":_vm.download}},[_c('span',{staticClass:"button-text-link__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }